import { hapticTap } from './haptics';

/** Háptica suave al agregar un producto al carrito (mostrador / piso ruidoso). Web no hace nada. */
export function hapticAddToCart(): void {
  hapticTap();
}
